
import { Component, Vue, Watch } from 'vue-property-decorator';
import { CountUp } from 'countup.js';
import { State, Mutation } from 'vuex-class';
import api from '@/api/org';
import { IORGSTATE } from '@/store/state.d';

@Component
export default class InfoCard extends Vue {
  @State(state => state.org.moduleUpdate.info) curStatus!: boolean;

  @Mutation('org/SET_ORG_INFO_STATUS') setInfoStatus !: Function;

  private countUp?: CountUp;

  private loading: Boolean = true;

  private title: string = '';

  private account: string = '';

  private inviteCode: string = '';

  public $refs!: {
    count: HTMLElement,
  }

  mounted() {
    this.countUp = new CountUp(this.$refs.count, 0, {
      prefix: '￥',
      decimal: '.',
      decimalPlaces: 2,
    });
    this.getOrgInfo();
  }

  // 根据机构Pid来获取机构信息
  getOrgInfo() {
    this.loading = true;
    api.getOrgInfo({ orgPid: this.$route.params.pid || '' }).then((res: any) => {
      (this.countUp as CountUp).update(res.balance);
      this.title = res.org.orgTitle;
      this.account = res.user.loginName;
      this.inviteCode = res.org.invitationCode;
      this.setInfoStatus(false);
      this.loading = false;
    });
  }

  @Watch('curStatus', { immediate: false, deep: true })
  handleStatusChange(v: boolean) {
    if (v) this.getOrgInfo();
  }
}
